<template>
  <v-container class="grey lighten-5 my-4">
    <v-row class="justify-start">
      <div class="accordeon-container">
        <div class="d-flex flex-row align-center justify-space-between px-5 py-2 mt-3">
          <div class="d-flex align-center">
            <h3 class="color-darkGray">PIX</h3>
          </div>
          <div>
            <v-btn
              v-if="!isButtonVisibilit"
              @click="openDialog()"
              class="br-8"
              height="40"
              color="secondary"
              small
              >Selecionar</v-btn
            >
          </div>
        </div>
        <p class="text-left px-5 py-2 mt-3 color-darkGray" v-if="validationPix">
          Ao selecionar PIX, você receberá um QR Code / Chave PIX para efetuar o pagamento.
        </p>
        <p class="text-left px-5 py-2 mt-3 color-darkGray" v-else>
          Para o método de pagamento PIX é necessário agendar a consulta com até 2h de antecedência.
        </p>
      </div>
    </v-row>
    <WarningDialog
      ref="warningDialog"
      @ok="onInput"
      text="O pagamento da consulta precisa estar aprovado até 2 horas antes da consulta ser realizada, ou esta será automaticamente cancelada. Poderá acompanhar o status do seu pagamento através do detalhe da consulta agendada."
    />
  </v-container>
</template>

<script>
import WarningDialog from './WarningDialog.vue';

export default {
  components: {
    WarningDialog,
  },
  props: {
    validationPix: Boolean,
  },
  data() {
    return {
      isButtonVisibilit: false,
    };
  },
  watch: {
    validationPix: {
      deep: true,
      handler(newValue, OldValue) {
        this.isButtonVisibilit = !newValue;
      },
    },
  },
  methods: {
    openDialog() {
      const { warningDialog } = this.$refs;
      if (!warningDialog) return;

      warningDialog.openDialog();
    },
    onInput() {
      this.$emit('input', { payment_method_type: 'pix' });
      this.isButtonVisibilit = true;
    },
  },
};
</script>

<style scoped>
.accordeon-container {
  width: 100%;
  max-width: 526px;
  background-color: #fffde3;
}
</style>
